<app-index-navbar></app-index-navbar>


<div class="px-4" style="margin-top:80px; ">
    <div class="flex flex-wrap">
        <div class="w-full px-4 flex-1">
            <span class="block my-4 p-3 rounded border border-solid border-blueGray-100">
                <section class="pt-8 border-gray-100 col-span-full lg:col-span-6 xl:col-span-7">
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex items-center text-lg">
                            <h1 class="m-0">Servicios</h1>
                            <span class="nb-results ml-3 font-normal text-gray-400">
                                {{(serviceItems | search:'name,description,status':query).length}}
                            </span>
                            <div class="relative hidden md:block ml-6 w-64">
                                <svg class="absolute left-2 top-1.5 text-gray-300 w-4"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    aria-hidden="true" focusable="false" role="img" width="1em" height="1em"
                                    preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                    <path class="uim-quaternary"
                                        d="M20.23 7.24L12 12L3.77 7.24a1.98 1.98 0 0 1 .7-.71L11 2.76c.62-.35 1.38-.35 2 0l6.53 3.77c.29.173.531.418.7.71z"
                                        opacity=".25" fill="currentColor"></path>
                                    <path class="uim-tertiary"
                                        d="M12 12v9.5a2.09 2.09 0 0 1-.91-.21L4.5 17.48a2.003 2.003 0 0 1-1-1.73v-7.5a2.06 2.06 0 0 1 .27-1.01L12 12z"
                                        opacity=".5" fill="currentColor"></path>
                                    <path class="uim-primary"
                                        d="M20.5 8.25v7.5a2.003 2.003 0 0 1-1 1.73l-6.62 3.82c-.275.13-.576.198-.88.2V12l8.23-4.76c.175.308.268.656.27 1.01z"
                                        fill="currentColor"></path>
                                </svg>
                                <input
                                    class="v2-text-filter h-7 w-full pl-7 text-sm border border-gray-200 shadow-inner rounded-full outline-none focus:ring-1 focus:shadow-xl placeholder-gray-400 focus:ring-inset dark:bg-gray-950"
                                    placeholder="Buscar servicios" type="search" value="" [(ngModel)]="query">
                            </div>
                        </div>
                    </div>
                    <div class="v2-filtered-list-results">
                        <div class="flex flex-wrap">
                            <div *ngFor="let service of serviceItems | search:'name,description,status':query">
                                <a [routerLink]="['/service/', service.id]">
                                    <app-service-item-card [serviceItem]='service'></app-service-item-card>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </span>
        </div>

        <!-- Filters area -->
        <div class="w-8/12 px-4">
            <span class="text-sm block my-4 p-3 text-blueGray-700 rounded border border-solid border-blueGray-100"
                style="max-width: 400px; background: #f1f1f069;">
                <section
                    class="pt-8 border-gray-100 hidden lg:block lg:col-span-4 xl:col-span-3 border-r bg-gradient-to-l from-gray-50-to-white">
                    <div class="v2-tag-filter-list ">
                        <div class="v2-tag-filter" filter-type="pipeline_tag" nb-displayed="10" single-choice="true">
                            <div class="flex items-baseline mb-3">
                                <h2>Texto</h2>
                            </div>
                            <div class="flex flex-wrap mb-4">
                                <!-- <a class="tag tag-white v2-tag-filter-entry"
                                    tag-id="fill-mask">
                                    <div class="tag-ico tag-ico-red">
                                        <app-fill-mask-svg></app-fill-mask-svg>
                                    </div>
                                    <span class="pr-5">Completar Máscara</span>
                                </a> -->
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="question-answering">
                                    <div class="tag-ico tag-ico-blue">
                                        <app-question-answering-svg></app-question-answering-svg>
                                    </div>
                                    <span class="pr-5">Preguntas-Respuestas</span>
                                </a>
                                <a class="tag tag-white v2-tag-filter-entry"
                                    tag-id="summarization">
                                    <div class="tag-ico tag-ico-indigo">
                                        <app-summary-svg></app-summary-svg>
                                    </div>
                                    <span class="pr-5">Resumen</span>
                                </a>
                                <!-- <a class="tag tag-white v2-tag-filter-entry"
                                    tag-id="table-question-answering">
                                    <div class="tag-ico tag-ico-green">
                                        <app-table-qna-svg></app-table-qna-svg>
                                    </div>
                                    <span class="pr-5">Preguntas sobre tablas</span>
                                </a> -->
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="text-classification">
                                    <div class="tag-ico tag-ico-orange">
                                        <app-text-classification-svg></app-text-classification-svg>
                                    </div>
                                    <span class="pr-5">Clasificación de texto</span>
                                </a>
                                <a class="tag tag-white v2-tag-filter-entry"
                                    tag-id="text-generation">
                                    <div class="tag-ico tag-ico-indigo">
                                        <app-text-generation-svg></app-text-generation-svg>
                                    </div>
                                    <span class="pr-5">Generación de textos</span>
                                </a>
                                <!-- <a class="tag tag-white v2-tag-filter-entry" style="visibility: collapse;"
                                tag-id="text2text-generation">
                                    <div class="tag-ico tag-ico-indigo">
                                        <app-text2text-generation-svg></app-text2text-generation-svg>
                                    </div>
                                    <span class="pr-5">Generación Texto-Texto </span>
                                </a> -->
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="token-classification">
                                    <div class="tag-ico tag-ico-blue">
                                        <app-token-classification-svg></app-token-classification-svg>
                                    </div>
                                    <span class="pr-5">Clasificación de Token</span>
                                </a>
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="translation">
                                    <div class="tag-ico tag-ico-green">
                                        <app-translation-svg></app-translation-svg>
                                    </div>
                                    <span class="pr-5">Traducción</span>
                                </a>
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="zero-shot-classification">
                                    <div class="tag-ico tag-ico-yellow">
                                        <app-zero-shot-class-svg></app-zero-shot-class-svg>
                                    </div>
                                    <span class="pr-5">Clasificación Zero-Shot</span>
                                </a>
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="question-generation">
                                    <div class="tag-ico tag-ico-blue">
                                        <app-question-answering-svg></app-question-answering-svg>
                                    </div>
                                    <span class="pr-5">Generación de preguntas</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    class="pt-8 border-gray-100 hidden lg:block lg:col-span-4 xl:col-span-3 border-r bg-gradient-to-l from-gray-50-to-white"
                    style="visibility:hidden">
                    <div class="v2-tag-filter-list ">
                        <div class="v2-tag-filter" filter-type="pipeline_tag" nb-displayed="10" single-choice="true">
                            <div class="flex items-baseline mb-3">
                                <h2>Imagen</h2>
                            </div>
                            <div class="flex flex-wrap mb-4">
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="fill-mask">
                                    <div class="tag-ico tag-ico-red">
                                        <app-fill-mask-svg></app-fill-mask-svg>
                                    </div>
                                    <span class="pr-5">Clasificación de imagen</span>
                                </a>
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="question-answering">
                                    <div class="tag-ico tag-ico-blue">
                                        <app-question-answering-svg></app-question-answering-svg>
                                    </div>
                                    <span class="pr-5">Segmentación de objetos</span>
                                </a>
                                <!-- <a class="tag tag-white v2-tag-filter-entry" tag-id="summarization">
                                    <div class="tag-ico tag-ico-indigo">
                                        <app-summary-svg></app-summary-svg>
                                    </div>
                                    <span class="pr-5">Colorear imagen</span>
                                </a>
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="table-question-answering">
                                    <div class="tag-ico tag-ico-green">
                                        <app-table-qna-svg></app-table-qna-svg>
                                    </div>
                                    <span class="pr-5">Noche/Día</span>
                                </a>
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="text-classification">
                                    <div class="tag-ico tag-ico-orange">
                                        <app-text-classification-svg></app-text-classification-svg>
                                    </div>
                                    <span class="pr-5">Transferencia de estilo</span>
                                </a> -->
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="obj-detection">
                                    <div class="tag-ico tag-ico-indigo">
                                        <app-text-generation-svg></app-text-generation-svg>
                                    </div>
                                    <span class="pr-5">Detección de objetos</span>
                                </a>
                                <!-- <a class="tag tag-white v2-tag-filter-entry" tag-id="text2text-generation">
                                    <div class="tag-ico tag-ico-indigo">
                                        <app-text2text-generation-svg></app-text2text-generation-svg>
                                    </div>
                                    <span class="pr-5">Reconstrucción de imagen</span>
                                </a>-->
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="token-classification">
                                    <div class="tag-ico tag-ico-blue">
                                        <app-token-classification-svg></app-token-classification-svg>
                                    </div>
                                    <span class="pr-5">Super resolución de imagen</span>
                                </a>
                                <!-- <a class="tag tag-white v2-tag-filter-entry" tag-id="translation">
                                    <div class="tag-ico tag-ico-green">
                                        <app-translation-svg></app-translation-svg>
                                    </div>
                                    <span class="pr-5">Imagen -> Texto</span>
                                </a>
                                <a class="tag tag-white v2-tag-filter-entry" tag-id="zero-shot-classification">
                                    <div class="tag-ico tag-ico-yellow">
                                        <app-zero-shot-class-svg></app-zero-shot-class-svg>
                                    </div>
                                    <span class="pr-5">Texto -> Imagen</span>
                                </a> -->
                            </div>
                        </div>
                    </div>
                </section>
            </span>
        </div>
    </div>
</div>
